export default function Header() {
  return (
    <header className="public-header flex-shrink-0 bg-black p-5 xl:p-10">
      <img className="w-40 xl:w-56" src="/images/logo.png" />
    </header>
  );
}
